import Vue from 'vue'
import AppLayout from './layout/AppIndex.vue'
import vuetify from './plugins/vuetify'
import router from './routes/router.js'
import store from './store/index.js'
import Utils from '@/plugins/utils.js'

Vue.config.productionTip = false
Vue.prototype.$utils = Utils

new Vue({
  vuetify,
  router,
  store,
  render: h => h(AppLayout)
}).$mount('#app')
